<template>
  <div class="popstyle2" style="padding: 0 12px;">
    <b-modal id="users-management-modal" ref="usersManagementModal" size="lg" :title="modalTitle"
             centered :hide-footer="true" style="margin-top: 0" @hidden="onHidden" disabled="true">
      <CierreLotesList :permisos="permisos"></CierreLotesList>
    </b-modal>
  </div>
</template>

<style scoped>
</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import Table from '@/components/Modules/Table/Table.vue';
import CierreLotesList from './cierre-lotes-list/CierreLotesList';

export default {
  name: 'CierreLotesManagement',
  props: ['permisos'],
  components: {CierreLotesList, Loader, Table},
  data () {
    return {
      loading: 0,
      columns: [
        {text: 'email', filterable: true},
        {text: 'first_name', filterable: true},
        {text: 'last_name', filterable: true},
        {text: 'Acciones', type: 'status'}
      ],
      options: {
        filterByColumn: true,
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100]
      },
      modalTitle: 'Cierre Lotes'
    };
  },
  computed: {},
  mounted: function () {
    this.$refs.usersManagementModal.show();
  },
  methods: {
    onHidden: function () {
      this.details = false;
      this.$parent.showCierreLotesManagement = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/cierre-lotes-management/CierreLotesManagement.vue